import { Optional } from "typescript-optional";
import { BaseCriteriaModel } from "./base-criteria.model";

export class MyEInvoiceFromIrbQueryCriteriaClass extends BaseCriteriaModel {
    hdr_guids: Optional<string[]> = Optional.empty();
    line_irb_hdr_guids: Optional<string[]> = Optional.empty();

    // hdr level string filters
    hdr_supplier_names: Optional<string[]> = Optional.empty();
    hdr_buyer_names: Optional<string[]> = Optional.empty();
    hdr_supplier_tax_ids: Optional<string[]> = Optional.empty();
    hdr_supplier_id_nos: Optional<string[]> = Optional.empty();
    hdr_supplier_sales_service_tax_ids: Optional<string[]> = Optional.empty();
    hdr_supplier_emails: Optional<string[]> = Optional.empty();
    hdr_supplier_standard_indu_class_codes: Optional<string[]> = Optional.empty();
    hdr_supplier_business_activity_descs: Optional<string[]> = Optional.empty();
    hdr_buyer_tax_ids: Optional<string[]> = Optional.empty();
    hdr_buyer_id_nos: Optional<string[]> = Optional.empty();
    hdr_buyer_sales_service_tax_ids: Optional<string[]> = Optional.empty();
    hdr_supplier_tourism_tax_ids: Optional<string[]> = Optional.empty();
    hdr_buyer_emails: Optional<string[]> = Optional.empty();
    hdr_supplier_addresses: Optional<string[]> = Optional.empty();
    hdr_buyer_addresses: Optional<string[]> = Optional.empty();
    hdr_supplier_contact_nos: Optional<string[]> = Optional.empty();
    hdr_buyer_contact_nos: Optional<string[]> = Optional.empty();
    hdr_einvoice_vers: Optional<string[]> = Optional.empty();
    hdr_einvoice_types: Optional<string[]> = Optional.empty();
    hdr_einvoice_code_nos: Optional<string[]> = Optional.empty();
    hdr_original_einvoice_ref_nos: Optional<string[]> = Optional.empty();
    hdr_supplier_digital_signatures: Optional<string[]> = Optional.empty();
    hdr_invoice_currency_codes: Optional<string[]> = Optional.empty();
    hdr_billing_frequencies: Optional<string[]> = Optional.empty();
    hdr_billing_periods: Optional<string[]> = Optional.empty();
    hdr_irb_doc_unique_ref_nos: Optional<string[]> = Optional.empty();

    // line level string filters
    line_classifications: Optional<string[]> = Optional.empty();
    line_item_names: Optional<string[]> = Optional.empty();
    line_tax_types: Optional<string[]> = Optional.empty();
    line_tax_exemption_details: Optional<string[]> = Optional.empty();
    line_uoms: Optional<string[]> = Optional.empty();
    line_settlement_methods: Optional<string[]> = Optional.empty();
    line_settlement_types: Optional<string[]> = Optional.empty();
    line_payment_terms: Optional<string[]> = Optional.empty();
    line_payment_reference_numbers: Optional<string[]> = Optional.empty();
    line_bill_reference_numbers: Optional<string[]> = Optional.empty();

    // hdr numeric filters
    hdr_currency_rate: Optional<number> = Optional.empty();
    hdr_tax_exemption_amount: Optional<number> = Optional.empty();
    hdr_sub_total: Optional<number> = Optional.empty();
    hdr_total_exclude_tax: Optional<number> = Optional.empty();
    hdr_total_include_tax: Optional<number> = Optional.empty();

    // line numeric filters
    line_unit_price: Optional<number> = Optional.empty();
    line_tax_rate: Optional<number> = Optional.empty();
    line_tax_amount: Optional<number> = Optional.empty();
    line_tax_exemption_amount: Optional<number> = Optional.empty();
    line_qty: Optional<number> = Optional.empty();
    line_discount_rate: Optional<number> = Optional.empty();
    line_discount_amount: Optional<number> = Optional.empty();
    line_payment_amount: Optional<number> = Optional.empty();
}